// ───────────────────────────────────────────────────────�
// APP.JS — entry router.
// The public pages (landing, instrument, solution and reports pages) are small and load here. Everything else — the
// logged-in platform and the token pages candidates open — lives in AppShell.js and is downloaded on demand, so a
// first-time visitor or a search-engine crawler no longer pulls the whole application.
// ───────────────────────────────────────────────────────�
import React, { Suspense, lazy, useState } from "react";
import { useAuth } from "./context/AuthContext.jsx";
import LandingPage from "./modules/LandingPage.jsx";
import InstrumentLandingPage from "./modules/InstrumentLandingPage.jsx";
import ReportsLandingPage from "./modules/ReportsLandingPage.jsx";

const AppShell = lazy(() => import("./AppShell.js"));

const goHome = () => { window.location.href = "/"; };

// Routes AppShell owns (candidate surveys, verification, admin, …). Anything with a ?token= is a candidate link.
export function isShellRoute(pathname, search) {
  if (pathname.startsWith("/verify/")) return true;
  if (["/portal", "/survey", "/360", "/manager-check", "/privacy/erasure", "/verify-email", "/reset-password", "/admin", "/sjt", "/cab"].includes(pathname)) return true;
  return new URLSearchParams(search).has("token");
}

function Loading() {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", fontFamily:"Plus Jakarta Sans,sans-serif", color:"#64748b" }}>
      <div>
        <div style={{ fontFamily:"Fraunces,serif", fontSize:24, color:"#0a1628", marginBottom:8 }}>
          AXIS<span style={{ color:"#c8964e", fontWeight:300 }}>360</span>
        </div>
        <div style={{ fontSize:12 }}>Loading…</div>
      </div>
    </div>
  );
}

export default function App() {
  const { user } = useAuth();
  const [showLanding, setShowLanding] = useState(true);
  const { pathname, search } = window.location;
  const path = pathname.replace(/\/$/, "");

  if (!isShellRoute(pathname, search)) {
    if (path === "/reports") return <ReportsLandingPage onBack={goHome} onEnter={goHome}/>;
    if (pathname.startsWith("/instruments/")) {
      return <InstrumentLandingPage slug={pathname.split("/instruments/")[1]?.replace(/\/$/, "")} category="instrument" onBack={goHome} onEnter={goHome}/>;
    }
    if (pathname.startsWith("/solutions/")) {
      return <InstrumentLandingPage slug={pathname.split("/solutions/")[1]?.replace(/\/$/, "")} category="solution" onBack={goHome} onEnter={goHome}/>;
    }
    if (showLanding && !user) return <LandingPage onEnter={() => setShowLanding(false)}/>;
  }

  // Landing already passed (or a signed-in user): the platform, loaded on demand.
  return (
    <Suspense fallback={<Loading/>}>
      <AppShell skipLanding={!showLanding}/>
    </Suspense>
  );
}
